import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Close as Cross, IkonateContext } from "react-ikonate";
import styles from "./index.module.css";

/**
 * The small "x" that sits inside the right edge of a search field and clears
 * it. Position it with `className` (it is absolutely positioned, vertically
 * centred) when the field has something else on the right, like a "?" hint.
 */
export default function ClearSearchButton({
  onClick,
  className,
  label = "Clear search",
}) {
  return (
    <button
      type="button"
      className={classNames(styles.button, className)}
      aria-label={label}
      title={label}
      // Keep focus in the field so the rep can type a new search straight away.
      onMouseDown={(e) => e.preventDefault()}
      onClick={onClick}
    >
      <IkonateContext.Provider
        value={{ size: 12, stroke: 2.5, color: "currentColor" }}
      >
        <Cross />
      </IkonateContext.Provider>
    </button>
  );
}

ClearSearchButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
};
